export const RecentSearchLimit = 5;
